import { EmptyState, Text } from '@box/blueprint-web';
import { BrokenForm } from '@box/blueprint-web-assets/illustrations/Medium';
import React from 'react';
import { useIntl } from 'react-intl';
import { useShouldRenderBlueprint } from '../../../common/useShouldRenderBlueprint';
import VariantComponent from '../../../common/variant-component';
import DisabledFormIcon from '../../../assets/icons/disabled-form';
import css from './disabled-form-page.module.scss';
import messages from './messages';

type DisabledFormEmptyStateProps = {
  formType: string;
  message: string;
};

const OldEmptyState = ({ message, formType }: DisabledFormEmptyStateProps) => {
  const intl = useIntl();
  return (
    <>
      <DisabledFormIcon />
      {formType === 'form' ? (
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
        <Text color="textOnLightDefault" variant="titleMedium">
          {intl.formatMessage(messages.disabledFormTitle)}
        </Text>
      ) : null}
      <div className={css.message}>{message}</div>
    </>
  );
};

const NewEmptyState = ({ message, formType }: DisabledFormEmptyStateProps) => {
  const intl = useIntl();
  return (
    <EmptyState
      body={
        <Text as="p" color="textOnLightDefault" variant="bodyDefault">
          {message}
        </Text>
      }
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
      heading={
        formType === 'form' ? (
          // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
          <Text color="textOnLightDefault" variant="titleMedium">
            {intl.formatMessage(messages.disabledFormTitle)}
          </Text>
        ) : null
      }
      illustration={BrokenForm}
    />
  );
};

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const DisabledFormEmptyState = (props: any) => {
  // Should be addressed in FORMS-21240
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      NewComponent={NewEmptyState}
      OldComponent={OldEmptyState}
      shouldRenderNewComponent={shouldRenderBlueprint}
      {...props}
    />
  );
};

export default DisabledFormEmptyState;
